// eslint-disable-next-line @typescript-eslint/naming-convention
export enum FILTER_POSITION {
  field = 0,
  operator = 1,
  operands = 2,
  extra = 3,
}
